<template>
    <v-card rounded="lg" class="mb-6" style="height:100%;">
        <v-card-title>
            <h2 v-if="isAcqui" class="mb-0 text-uppercase" style="width:100%; align-items:center;">{{$t(title)}}</h2>
            <h3 v-else class="black--text" style="text-transform:none;">{{$t(title)}}</h3>
        </v-card-title>
        <v-card-text>
            <DonutComponent :dataSet="graphData" :legend="false" style="height:200px;"/>
            <div class="legend mr-6">
                <div v-for="(legend, index) in (this.legends)" style="cursor:pointer" :key="'legend_'+index">
                    <span :style="'width: 20px; height:10px; display:inline-block; background-color:'+backgroundRefs[index]"></span> {{to_trad ? $t(legend) : legend}}
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import DonutComponent from '@/components/graphs/DonutComponent'

export default {
    name: 'campDonutComponent',
    props: ['data', 'title', 'to_trad', 'isAcqui'],
    components: {DonutComponent},
    data() {
        return {   
            graphData: {}, 
            backgroundRefs:[
                "#2563EB", "#3B82F6", "#06B6D4", "#14B8A6", "#10B981",
                "#84CC16", "#FACC15", "#F59E0B", "#FB923C", "#F97316",
                "#EF4444", "#F43F5E", "#EC4899", "#A855F7", "#6366F1",
                "#C084FC", "#64748B", "#94A3B8", "#A5F3FC", "#86EFAC"
            ],
            legends:{}
        }
    },
    methods: {
        
    },
    mounted() {
        this.graphDataFct();
    },
    created() {
        this.graphDataFct();
    },
    methods: {
        getObjectiveForm(){
            this.$emit('editCallStats');
        },
        graphDataFct(){
            let graphData = {}
            graphData.datasets = [];
            let dataset = {};

            let arrayData = [];
            for (var label in this.data) {
                arrayData.push([label, this.data[label]]);
            }
            arrayData.sort(function(a, b) {
                return b[1] - a[1];
            });

            let objSorted = {}
            arrayData.forEach(function(item){
                objSorted[item[0]]=item[1]
            })

            let isEmpty = false;
            if(this.data.length == 0){
                isEmpty = true;
            } else {
                let num = 0;
                for (var key in this.data) {
                    if (this.data.hasOwnProperty(key)) {
                        if(this.data[key] != 0){
                            num += this.data[key];
                        } 
                    }
                }
                if(num == 0){
                    isEmpty = true;
                }
            }


            this.legends = Object.keys(objSorted);
        
            let labels = Object.keys(objSorted);
            if(this.to_trad){
                labels = labels.map(label => this.$t(label));
            }

            dataset.label = "";          
            dataset.data = (isEmpty ? [100] : Object.values(objSorted));
            dataset.backgroundColor =  (isEmpty ? ['#DDD'] : this.backgroundRefs.slice(0, objSorted.length));
            graphData.datasets.push(dataset);
            graphData.labels = (graphData.total == 0 ? [this.$t('nodata')] : labels)
            //graphData.labels = (graphData.total == 0 ? [this.$t('nodata')] : this.labels);
            this.graphData = graphData;
        },
    },
}
</script>